import { render, staticRenderFns } from "./SchoolCarousel.vue?vue&type=template&id=0b3dd2a1&scoped=true&"
import script from "./SchoolCarousel.vue?vue&type=script&lang=js&"
export * from "./SchoolCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCarousel.vue?vue&type=style&index=0&id=0b3dd2a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3dd2a1",
  null
  
)

export default component.exports